import { isAxiosError } from 'axios';
import { Api } from 'lib/api';
import toast from 'react-hot-toast';

const initialState = {
  digitalProducts: {
    data: [],
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
    },
  },
  digitalProductsDetail: {},
};

const createDigitalProductsSlice = (set) => ({
  ...initialState,
  getDigitalProductsByAuthor: async ({ authorId }) => {
    try {
      const res = await Api.get(`/admin/digital-products/author/${authorId}`);
      set((state) => ({ ...state, digitalProducts: res }));
    } catch (error) {
      if (isAxiosError(error)) toast({ type: 'error', message: error.response?.data.message });
      throw new Error(error);
    }
  },
  getDigitalProductsDetail: async ({ productId }) => {
    try {
      const res = await Api.get(`/admin/digital-products/${productId}`);
      set((state) => ({ ...state, digitalProductsDetail: res }));
    } catch (error) {
      if (isAxiosError(error)) toast.error(error?.response?.data?.message);
      toast.error('Something went wrong');
      throw new Error(error);
    }
  },

  deleteDigitalProducts: async ({ productId }, callback) => {
    try {
      await Api.delete(`/admin/digital-products/${productId}`);
      set((state) => ({
        ...state,
        digitalProducts: {
          ...state.digitalProducts,
          data: state.digitalProducts.data.filter((item) => item._id !== productId),
        },
      }));
      toast.success('Digital product deleted successfully');

      callback?.();
    } catch (error) {
      if (isAxiosError(error)) toast.error(error?.response?.data?.message);
      toast.error('Something went wrong');
      throw new Error(error);
    }
  },
});

export default createDigitalProductsSlice;
